import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  styled,
  tableCellClasses,
} from "@mui/material";
import React from "react";

import Fuse from "fuse.js";
import { GetUserRolesResponse } from "../../../models/role.model";
import PermissionRoleTableRows from "./PermissionRoleTableRows";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#DAE0E4",
    color: "#1D4A87",
    fontSize: "14px",
    marginBottom: "50px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: "#34495E",
  },
}));

interface Props {
  userOfficeRoles: GetUserRolesResponse[];
  setUpdateGetUserOfficeRoles: any;
  setUserOfficeRoles: any;
  userId: number;
  setSearchTerm: (searchTerm: string) => void;
  searchTerm: string;
}
const PermissionRoleTable = ({
  userOfficeRoles,
  setUpdateGetUserOfficeRoles,
  setUserOfficeRoles,
  userId,
  setSearchTerm,
  searchTerm,
}: Props) => {
  const columns = [
    {
      id: "roles",
      title: "نقش های سازمانی",
    },

    {
      id: "date",
      title: "زمان اعطا",
    },
    {
      id: "creatorUser",
      title: "کاربر اعطا کننده",
    },
    {
      id: "permissions",
      title: "مجوزهای اختصاصی",
    },
  ];

  const fuse = new Fuse(userOfficeRoles, {
    keys: ["title"],
    includeScore: true,
    threshold: 0.1,
    ignoreLocation: true,
    useExtendedSearch: true,
  });
  const results = fuse.search(searchTerm);
  const searchResults = searchTerm
    ? results.map((title) => title.item)
    : userOfficeRoles;

  return (
    <>
      <TableContainer component={Paper} sx={{ maxHeight: 400 }}>
        <Table
          stickyHeader
          sx={{ minWidth: { xs: 0, sm: 0, md: 700, lg: 900 } }}
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              {columns.length > 0 &&
                columns.map((column) => (
                  <StyledTableCell align="center">
                    {column.title}
                  </StyledTableCell>
                ))}
              <StyledTableCell align="center">
                <MoreHorizIcon />
              </StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody
            sx={{
              outline: "1px solid #DAE0E4",
            }}
          >
            {userOfficeRoles?.length !== 0 &&
              searchResults
                ?.map((role: GetUserRolesResponse, index: number) => (
                  <>
                    <PermissionRoleTableRows
                      role={role}
                      setUserOfficeRoles={setUserOfficeRoles}
                      userOfficeRoles={userOfficeRoles}
                      userId={userId}
                    />
                  </>
                ))
                .reverse()}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PermissionRoleTable;
